import { Component, HostBinding, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Market } from '@core/dto/Market';
import { LocaleService } from '@core/service/locale.service';

@Component({
  selector: 'app-oops',
  templateUrl: './email-not-found.component.html',
  styleUrls: ['../login-pages.scss', './email-not-found.component.css'],
})
export class EmailNotFoundComponent implements OnInit {
  email: string;

  @HostBinding('class')
  cssClasses = 'hide-footer';

  currentLocale: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public localeService: LocaleService
  ) {}

  ngOnInit(): void {
    this.currentLocale = this.localeService.getCurrentLocale();
    this.email = this.route.snapshot.queryParamMap.get('email');
  }

  goBack() {
    this.router.navigateByUrl('/');
  }
}
